export const config = {
  app: "ai-imagery",
  appTitle: "Ai-Imagery — AI-Powered Self-Service Image Optimization",
  appFavicon: "assets/images/favicon-ai.ico",
  supportMailID: "catexpert.team@ab-inbev.com",
};
